import React, { useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useSnackbar } from 'notistack';
import UTextField from 'components/UTextField';
import UButton from 'components/UButton';
import UPaper from 'components/UPaper';
import schema from './schema';

import { ConsultaContext } from '../Context';

const useStyles = makeStyles((theme) => ({
  formContainer: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
}));

function Form() {
  const classes = useStyles();

  const {
    handleSubmit, register, errors, reset,
  } = useForm({
    validationSchema: schema,
  });

  const { enqueueSnackbar } = useSnackbar();

  const {
    fetch, loading, data, error,
  } = useContext(ConsultaContext);

  useEffect(() => {
    if (error && error.message) {
      reset({ codigo: '' });
      const { message } = error;
      enqueueSnackbar(message, { variant: 'error' });
    }
  }, [error, reset, enqueueSnackbar]);

  const onSubmit = (form) => fetch(form.codigo);

  return !data && (
    <UPaper insetSize="1x" fullWidth>
      <form className={classes.formContainer} onSubmit={handleSubmit(onSubmit)} noValidate>
        <UTextField
          margin="normal"
          required
          fullWidth
          label="Código Validação"
          name="codigo"
          autoComplete="codigo"
          autoFocus
          inputRef={register}
          error={Boolean(errors.codigo)}
          helperText={errors.codigo && errors.codigo.message}
          disabled={loading}
        />
        <UButton
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          size="large"
          disabled={loading}
          endIcon={<ArrowForwardIcon />}
        >
          Buscar
        </UButton>
      </form>
    </UPaper>
  );
}

export default Form;
